<template>
  <v-row class="agenda" no-gutters justify="center">
    <v-col cols="6">
      <div
        @click="beforeDay"
        class="btn-change-date my-8"
        v-bind:class="{ opacity20: isBeforeTomorrow }"
      >
        <v-icon color="#FFFFFF" small>mdi-arrow-left</v-icon> Dia anterior
      </div>
    </v-col>

    <v-col cols="6">
      <div @click="nextDay" class="btn-change-date my-8 text-right">
        Próximo dia <v-icon color="#FFFFFF" small>mdi-arrow-right</v-icon>
      </div>
    </v-col>
    <Day
      @selected="openConfirmScheduleDialog"
      :date="currentSelectedDate"
      :free-times="freeTimes"
      :classrooms="classrooms"
      :professor-id="selectedProfessor ? selectedProfessor.user_id : ''"
    />
    <Day
      @selected="openConfirmScheduleDialog"
      :date="tomorrow"
      :free-times="freeTimes"
      :classrooms="classrooms"
      :professor-id="selectedProfessor ? selectedProfessor.user_id : ''"
    />
    <Day
      @selected="openConfirmScheduleDialog"
      :date="afterTomorrow"
      :free-times="freeTimes"
      :classrooms="classrooms"
      :professor-id="selectedProfessor ? selectedProfessor.user_id : ''"
    />
    <ConfirmScheduleDialog
      v-if="scheduleInformation && userProfile"
      :hour="scheduleInformation.hour"
      :free-times="scheduleInformation.value.availableTimes"
      :date="scheduleInformation.date"
      :credits="userProfile.credit_amount"
      :schedule-information="scheduleInformation"
      :visibility="dialogConfirmSchedule"
      :professor-id="selectedProfessor ? selectedProfessor.user_id : false"
      :professors="professors"
      @close="dialogConfirmSchedule = false"
      @positive="showAgenda"
      :classroom="scheduleInformation.value.availableClassrooms[0]"
    />
  </v-row>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";

import Day from "../Day";
import ConfirmScheduleDialog from "@/components/dialogs/ConfirmScheduleDialog";
import StudentsRepository from "@/repositories/StudentsRepository";
import UserRepository from "@/repositories/UserRepository";

export default {
  props: {
    subject: Object,
    affiliateId: Number,
    selectedProfessor: Object,
    professors: Array
  },
  components: {
    Day,
    ConfirmScheduleDialog
  },
  data() {
    return {
      dialogConfirmSchedule: false,
      scheduledConfirmed: false,
      currentSelectedDate: new Date(new Date().getTime() + 86400000),
      today: new Date(),
      classrooms: [],
      freeTimes: [],
      scheduleInformation: undefined
    };
  },
  computed: {
    ...mapState(["userProfile"]),
    tomorrow() {
      let date = new Date(this.currentSelectedDate.getTime() + 86400000);

      return date;
    },
    afterTomorrow() {
      let date = new Date(this.currentSelectedDate.getTime() + 2 * 86400000);

      return date;
    },
    isToday() {
      let newDate = new Date(this.currentSelectedDate.getTime());

      return newDate.getTime() <= this.today.getTime();
    },
    isBeforeTomorrow() {
      let newDate = new Date(this.currentSelectedDate.getTime());
      let tomorrow = new Date(this.today.getTime() + 86400000);
      return newDate.getTime() <= tomorrow;
    }
  },
  mounted() {
    window.scrollTo(0, 0);

    this.showAgenda();
  },
  methods: {
    async showAgenda() {
      this.$store.commit("loadingStart", true);

      const [response, professors] = await Promise.all([
        StudentsRepository.listAvailableClasses(
          this.subject.id,
          this.affiliateId
        ),
        UserRepository.professors(this.subject.id)
      ]);

      this.buildDays(response.data);
      this.$store.commit("loadingFinish", true);
    },
    buildDays({ classrooms, free_times }) {
      this.classrooms = classrooms;
      this.freeTimes = free_times;
    },
    nextDay() {
      this.currentSelectedDate = new Date(
        this.currentSelectedDate.getTime() + 86400000
      );
    },
    beforeDay() {
      let newDate = new Date(this.currentSelectedDate.getTime() - 86400000);

      if (newDate.getTime() > this.today.getTime()) {
        this.currentSelectedDate = newDate;
      }
    },
    openConfirmScheduleDialog(scheduleInformation) {
      this.dialogConfirmSchedule = false;
      this.dialogConfirmSchedule = true;
      this.scheduleInformation = scheduleInformation;
    }
  }
};
</script>

<style>
.btn-change-date {
  color: #ffffff;
  line-height: 2;
  font-size: 13px;
  cursor: pointer;
}
.agenda {
  padding: 6px;
}
.opacity20 {
  opacity: 0.2;
}
</style>
